import { useMutation } from 'react-query';

import { mutations } from '~/constants/mutationKeys';
import { VinovestNetworkingHelper } from '~/helpers/VinovestNetworkingHelper';
import { TransferFundsPayload } from '~/networking/api/managed/responses/payments/PostTransferFunds';

export const usePostTransferFundsMutation = () => {
    return useMutation([mutations.PostTransferFunds], async (payload: TransferFundsPayload) => {
        const { managed } = VinovestNetworkingHelper.getClient();
        return managed.postTransferFunds(payload);
    });
};
